import styles from 'css/src/components/common/ui/StackedCanvasPreview.module.scss';

import React from 'react';
import classNames from 'classnames';

import { BUTTON_SIZES, SecondaryButton } from './Button';
import { CanvasPreview } from './CanvasPreview';
import ClickableHoverOverlay from './clickable-hover-overlay';

interface IStackedCanvasPreview {
    hoverText?: string;
    buttonText?: string;
    className?: string;
    sourceCanvas: HTMLCanvasElement | undefined;
    onClick?: React.MouseEventHandler<HTMLCanvasElement>;
}

export const StackedCanvasPreview = ({
    hoverText,
    buttonText,
    className,
    sourceCanvas,
    onClick,
}: IStackedCanvasPreview) => {
    return (
        <div
            className={classNames(
                styles['stacked-canvas-preview'],
                'w-100 parent position-relative d-flex',
            )}
        >
            <div className={styles['stacked-canvas-preview__stack']} />
            <div className={styles['stacked-canvas-preview__stack']} />
            <div
                className={classNames(
                    styles['stacked-canvas-preview__stack'],
                    styles['stacked-canvas-preview__canvas'],
                )}
            >
                {sourceCanvas ? (
                    <ClickableHoverOverlay hoverText={hoverText}>
                        <CanvasPreview
                            className={className}
                            sourceCanvas={sourceCanvas}
                            onClick={onClick}
                        />
                    </ClickableHoverOverlay>
                ) : (
                    <div className={styles['stacked-canvas-preview__placeholder']} />
                )}
            </div>
            {sourceCanvas && buttonText && (
                <div
                    className={classNames(
                        'position-absolute w-100 h-100 top-0 d-flex align-items-center justify-content-center',
                        styles['stacked-canvas-preview__overlay'],
                    )}
                >
                    <SecondaryButton
                        className={styles['stacked-canvas-preview__button']}
                        size={BUTTON_SIZES.SM}
                        text={buttonText}
                    />
                </div>
            )}
        </div>
    );
};
